import { useEffect, useState } from 'react';

import { formatTime } from '../../../../../utils/time';
import { useWidgetAdaptiveText } from '../../../hooks';

import styles from './BingoWidgetTimer.module.scss';

interface BingoWidgetTimerProps {
  eventId: string;
  startsInMs: number;
  extended?: boolean;
}

export function BingoWidgetTimer(props: BingoWidgetTimerProps) {
  const { startsInMs, extended, eventId } = props;
  const [timeLeft, setTimeLeft] = useState(startsInMs);
  const { textRef } = useWidgetAdaptiveText({ padding: 4 });

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => Math.max(0, prev - 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (eventId) {
      setTimeLeft(startsInMs);
    }
  }, [eventId, startsInMs]);

  return (
    <div className={extended ? styles.containerExtended : styles.container} data-testid="bingo-next-event-countdown">
      <span ref={textRef} className={extended ? styles.textExtended : styles.text}>
        {formatTime(timeLeft, 'ms')}
      </span>
    </div>
  );
}
